/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-group-sm .form-control{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.form-group-sm select.form-control:not([size]):not([multiple]){height:calc(1.8125rem + 2px)}"];
export { styles as styles };
